module.exports = __webpack_public_path__ + "img/Techeye.11491b3f.png";